
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"ordered-list"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.875 3.125h12.5m-12.5 7.5h12.5m-12.5 7.5h12.5M.668 15.302a1.25 1.25 0 111.208 1.573 1.25 1.25 0 11-1.204 1.583M.625 9.375a1.25 1.25 0 112.5 0c0 .405-.137.797-.39 1.113l-2.11 1.387h2.5M.625.625h.625a.625.625 0 01.625.625v4.375m-1.25 0h2.5","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    